import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.grayLight};
	padding: 1rem;
`;
export const TitleModal = styled.h6`
	font-weight: bold;
	font-size: 1.425rem;
	margin: 0;
`;
export const AreaHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const AreaFooter = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.grayLight};
`;

export const AreaReason = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 0.4rem;
`;
